module.exports = __webpack_public_path__ + "static/media/ergoappintro.8812a8aa.webm";